import React, {useContext} from 'react';

import {Integer} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';

type Props = {
    totalCount: number,
    selection: {ids: (string | number)[], inverted: boolean},
    disabled: boolean,
};

export const SelectedItemsView = (props: Props) => {
    const {totalCount, selection: {inverted, ids}, disabled = false} = props;
    const {locale} = useContext(LocaleContext);

    let selected = 0;
    if ((ids.length < totalCount && inverted) || (ids.length > 0 && !inverted)) {
        selected = inverted ? totalCount - ids.length : ids.length;
    }
    const content = <>{Integer.format(selected, locale)} Selected</>;

    if (disabled) {
        return <span className="disabled">{content}</span>;
    }

    return content;
};
